/**
 * Pure helper for normalizing the "empty = all enabled" convention at the
 * API/DB boundary into an explicit list the UI can work with.
 */

import {
    IDraftTopicDetail,
    IEnabledClauseSelection,
} from "@/api/clause-checklists/checklist-generation.types";

/**
 * Normalize a topic's enabled_clauses: if empty (meaning "all enabled"),
 * expand to the explicit full list of all clause-section combos.
 * This ensures the UI always works with explicit lists — the "empty = all"
 * convention only exists at the API/DB boundary.
 */
export function normalizeEnabledClauses(
    topic: IDraftTopicDetail
): IDraftTopicDetail {
    if (topic.enabled_clauses.length > 0) return topic;

    const allEntries: IEnabledClauseSelection[] = [];
    for (const clause of topic.all_clauses) {
        if (clause.document_section_types.length === 0) {
            allEntries.push({
                topic_clause_id: clause.topic_clause_id,
                document_section_type_id: null,
            });
        } else {
            for (const dst of clause.document_section_types) {
                allEntries.push({
                    topic_clause_id: clause.topic_clause_id,
                    document_section_type_id: dst.id,
                });
            }
        }
    }
    return { ...topic, enabled_clauses: allEntries };
}
